import { render, staticRenderFns } from "./EcommerceRevenueReport.vue?vue&type=template&id=166680d8&"
import script from "./EcommerceRevenueReport.vue?vue&type=script&lang=js&"
export * from "./EcommerceRevenueReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('166680d8')) {
      api.createRecord('166680d8', component.options)
    } else {
      api.reload('166680d8', component.options)
    }
    module.hot.accept("./EcommerceRevenueReport.vue?vue&type=template&id=166680d8&", function () {
      api.rerender('166680d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/ecommerce/EcommerceRevenueReport.vue"
export default component.exports